<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="date"
    persistent
    lazy
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <form-input :name="name" @focus="modal = true"></form-input>
    </template>
    <v-date-picker v-model="fields[name].value" :min="minDate" first-day-of-week="1" locale="ru" scrollable>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">Отмена</v-btn>
      <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/create-form/Input'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')
  export default {
    name: 'Calendar',
    data () {
      return {
        date: new Date().toISOString().substr(0, 10),
        modal: false,

      }
    },
    props: ['name', 'min'],
    computed: {
      ...mapState([
        'fields'
      ]),
      minDate () {
        if (this.min) {
          return this.fields[this.min].value
        }
      }
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
      hide () {
        this.$emit('close')
      },
      isValidDate (date) {
        return date instanceof Date && !isNaN(date.getTime())
      }
    },
    watch: {
      dateField () {
        this.dateLocal = this.dateField
        this.$emit('dateStartChange', this.dateLocal)
        this.$emit('dateEndChange', this.dateLocal)
      }
    },
    components: {
      FormInput
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/create-form/Calendar.vue